module.exports = "<app-pivot></app-pivot>"